import React from "react";
import {
  createProductTag,
  updateProductTag,
} from "../../../network/network";
import LocalizedNameFormModal from "../../../components/LocalizedNameFormModal";

const OptionFormModal = (props) => {
  return (
    <LocalizedNameFormModal
      {...props}
      createRequest={createProductTag}
      updateRequest={updateProductTag}
      addTitleKey="option_add"
      editTitleKey="option_edit"
      addSubmitKey="option_add"
      nameRequiredKey="option_name_required"
      addedTitleKey="option_added"
      addedDescriptionKey="option_added_successfully"
      updatedTitleKey="option_updated"
      updatedDescriptionKey="option_updated_successfully"
    />
  );
};

export default OptionFormModal;
